import log from 'salvo-lite/log'

import axios from 'axios'

class Checkout {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
        this._freeGift = new FreeGift()
        this._resetCheckoutLinks = document.querySelectorAll('[data-reset-checkout]')
        this._checkoutLinks = document.querySelectorAll('a')
        log.debug(this._name, 'Constructed', this)
    }

    onInit () {
        this._freeGift.onInit()
        this.incorrectFieldCheck()
        this.resetCheckoutLinks()
        this.backToCustomerInfoCheck()
        log.debug(this._name, 'Initiated', this)
    }

    goToFirstStep () {
        let goToCheckoutBtn = document.querySelector('[data-validation-check]')
        let termsCheckbox = document.querySelector('input#termsOfPurchase')
        if (goToCheckoutBtn) {
            if (termsCheckbox && !termsCheckbox.checked) {
                termsCheckbox.click()
            }
            goToCheckoutBtn.click()
        }
    }

    incorrectFieldCheck () {
        if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.step === 'contact_information') {
            let errorFields = document.querySelectorAll('[data-customer-information-form] .field--error')
            let goToCheckoutBtn = document.querySelector('[data-validation-check]')
            let termsCheckbox = document.querySelector('input#termsOfPurchase')
            log.debug(this._name, 'Error Triggered', this)
            if (errorFields.length > 0 && goToCheckoutBtn) {
                if (termsCheckbox && !termsCheckbox.checked) {
                    termsCheckbox.click()
                }
                goToCheckoutBtn.click()
            }
        }
    }

    resetCheckoutLinks () {
        for (let linkElem of this._resetCheckoutLinks) {
            linkElem.addEventListener('click', async e => {
                e.preventDefault()
                await axios.get(linkElem.getAttribute('href'))
                window.location.reload()
            })
        }
    }

    backToCustomerInfoCheck () {
        if (localStorage.getItem('CHECKOUT_START_STEP') && localStorage.getItem('CHECKOUT_START_STEP') === '1') {
            localStorage.removeItem('CHECKOUT_START_STEP')
            this.goToFirstStep()
        }
        for (let linkElem of this._checkoutLinks) {
            linkElem.addEventListener('click', e => {
                if (linkElem.dataset.trekkieId && linkElem.dataset.trekkieId === 'breadcrumb_cart_link') {
                    return true
                }
                if (linkElem.getAttribute('href').includes('?step=contact_information') && window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.step !== 'contact_information') {
                    // Set localStorage to auto go to the first step
                    localStorage.setItem('CHECKOUT_START_STEP', 1)
                    return true
                }
            })
        }
    }
}

class FreeGift {
    constructor () {
        this._name = this.constructor.name
        this._cart = null
        this._freeGift = null
        this._oldVariant = null
        this._requiredIds = null
        this._endPoints = {
            'add': '/cart/add.js',
            'cart': '/cart.js',
            'change': '/cart/change.js',
            'product': '/products/[PRODUCT-HANDLE].js'
        }
    }

    onInit () {
        this.getData(this._endPoints.cart).then(resp => {
            this._cart = resp.data
            this._checkForFreeGift()
            if (this._freeGift) this._checkForRequiredProducts()
        })
    }

    _checkForRequiredProducts () {
        this._requiredIds = this._freeGift.properties['ignore_pf_ids'].split('|')

        let allInCart = false
        let freeGiftQty = this._freeGift.quantity

        for (let id of this._requiredIds) {
            allInCart = false
            for (let item of this._cart.items) {
                if (`${item.product_id}` !== id) continue
                if (item.quantity < freeGiftQty) freeGiftQty = item.quantity
                allInCart = true
                break
            }
            if (!allInCart) break
        }

        if (freeGiftQty !== this._freeGift.quantity && allInCart) this._changeFreeGiftQty(freeGiftQty)
        if (allInCart) return true
        this._swapFreeGift()
    }

    _changeFreeGiftQty (qty) {
        log.debug(this._name, 'CHANGE FREE GIFT QUANTITY', qty)
        this.postData(this._endPoints.change, {
            'id': `${this._freeGift.variant_id}`,
            'quantity': qty
        })
    }

    _swapFreeGift () {
        let productEndPoint = this._endPoints.product.replace('[PRODUCT-HANDLE]', this._freeGift.handle)
        this.getData(productEndPoint).then(resp => {
            this._oldVariant = this._freeGift
            this._freeGift = resp.data
            this._getOptionPos()
        })
    }

    _getOptionPos () {
        let optionPosition = null
        for (let option of this._freeGift.options) {
            let optionHandle = option.name.toLowerCase().replace(' ', '-')
            if (optionHandle !== 'free-gift') continue
            optionPosition = option.position
            break
        }
        this._getVariant(optionPosition)
    }

    _getVariant (optionIndex) {
        let newVariant = null
        for (let variant of this._freeGift.variants) {
            if (variant[`option${optionIndex}`].toLowerCase() !== 'no') continue
            newVariant = variant
            break
        }
        this._newVariant = newVariant
        this._swapVariant(newVariant)
    }

    _swapVariant () {
        this.postData(this._endPoints.change, {
            'id': `${this._oldVariant.id}`,
            'quantity': 0
        }).then(resp => {
            this.postData(this._endPoints.add, {
                'id': this._newVariant.id,
                'quantity': 1
            }).then(resp => {
                window.location.reload()
            })
        })
    }

    _checkForFreeGift () {
        for (let item of this._cart.items) {
            if (!item.properties) continue
            if (!item.properties['free-gift']) continue
            this._freeGift = item
            break
        }
    }

    getData (url) {
        return axios.get(url)
    }

    postData (url, data) {
        return axios.post(url, data)
    }
}

export default Checkout



// WEBPACK FOOTER //
// ./src/scripts/pages/Checkout.js